import requestInstance from "./Request";
import { API_ENDPOINT } from "./Api";

let env = process.env.REACT_APP_API_BASE_URL

// Reupload compliance service
export const postReuploadCompliance = async (formData) => {
  try {
    const response = await requestInstance.post(
      `${env}/admin-api/v3/compliance-resubmit`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Reupload Compliance error:", error);
    throw error;
  }
};
